import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../services/utilityFunctions';
import translate from '../translate';
import FormInput from './FormInput';
import ConfigsContext from '../../contextProviders/ConfigsContext';
import MarketInfosContext from '../../contextProviders/MarketInfosContext';

function FormUserTypeInput(props) {
  const {
    value,
    onChange,
    t,
    showLabel,
    inputClassName,
    labelClassName,
    containerClassName,
  } = props;
  const { organization } = useContext(ConfigsContext);
  const { userTypes } = organization;
  const { marketInfos } = useContext(MarketInfosContext);
  const { localLanguage } = marketInfos;

  const types = [
    {
      id: 'collaborator',
      text:
        userTypes?.collaborator[localLanguage] || t('user_type_collaborator'),
    },
    {
      id: 'customer',
      text: userTypes?.customer[localLanguage] || t('user_type_customer'),
    },
    // Only distributors and customers are available (https://bravon.atlassian.net/browse/BRAVON-5012)
    // {
    //   id: 'lead',
    //   text: userTypes?.lead[localLanguage] || t('user_type_lead'),
    // },
    // {
    //   id: 'recommendation',
    //   text:
    //     userTypes?.recommendation[localLanguage] ||
    //     t('user_type_recommendation'),
    // },
    // {
    //   id: 'visitor',
    //   text: userTypes?.visitor[localLanguage] || t('user_type_visitor'),
    // },
  ];

  return (
    <FormInput
      id="type"
      name="type"
      type="select"
      label={showLabel && t('user.type')}
      labelClassName={labelClassName || 'col-lg-3 col-sm-12'}
      inputClassName={inputClassName}
      placeholder={t('user.type')}
      value={value}
      onChange={onChange}
      groupProps={{ className: 'row' }}
      containerClassName={containerClassName || 'col-lg-9 col-sm-12'}
      inputProps={{
        items: types,
      }}
    />
  );
}

FormUserTypeInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  showLabel: PropTypes.bool,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

FormUserTypeInput.defaultProps = {
  value: '',
  showLabel: true,
  inputClassName: '',
  labelClassName: '',
  containerClassName: '',
};

export default compose(translate)(FormUserTypeInput);
